import React from 'react';

const SIZES = {
  sm:  'w-5 h-5 border-2',
  md:  'w-8 h-8 border-2',
  lg:  'w-10 h-10 border-[3px]',
};

interface LoaderProps {
  size?: keyof typeof SIZES;
  className?: string;
}

export function Loader({ size = 'md', className = '' }: LoaderProps) {
  return (
    <div
      className={`rounded-full border-accent border-t-transparent animate-spin ${SIZES[size]} ${className}`}
      role="status"
      aria-label="Cargando"
    />
  );
}

export function LoaderCenter({ size = 'md' }: { size?: keyof typeof SIZES }) {
  return (
    <div className="flex items-center justify-center py-16">
      <Loader size={size} />
    </div>
  );
}
